import { createExcelAndDownload } from '../../../../utils/reportExcelExport';
import { withFeeCollectionExtraFields } from './feeCollectionReportFields';

export function Report(vouchers, hasBankIntegration = false) {
    const includeBankGl =
        hasBankIntegration ||
        vouchers.some(
            (voucher) =>
                voucher?.company_has_bank_integration ||
                voucher?.bank_gl ||
                voucher?.payment_method === 'Bank'
        );

    const customHeadings = [
        { key: "invoice_no", label: "Voucher No" },
        { key: "memberId", label: "Member ID" },
        { key: "member_id.name", label: "Member Name" },
        { key: "package_name", label: "Package Name" },
        { key: "trainer_name", label: "Trainer Name" },
        { key: "member_id.gender", label: "Gender" },
        { key: "member_id.phone", label: "Phone Number" },
        { key: "member_status", label: "Member Status" }, 
        { key: "voucher_date", label: "Issue Date", isDate: true },
        { key: "invoice.due_date", label: "Due Date", isDate: true },
        { key: "paid_date", label: "Paid Date", isDate: true },
        { key: "invoice.total_amount", label: "Due Amount" },
        { key: "voucher_complete_head", label: "Voucher Complete Head" },
        { key: "gross_amount", label: "Gross Amount" },
        { key: "discount_amount", label: "Discount Amount" },
        { key: "net_amount", label: "Net Amount" },
        { key: "voucher_type", label: "Voucher Type" },
        { key: "invoice.trainer_fee", label: "Trainer Fee" },
        { key: "paid_amount", label: "Paid Amount" },
        { key: "payment_method", label: "Payment Method" },
        { key: "reference_number", label: "Payment Reference" },
        ...(includeBankGl ? [{ key: "bank_gl", label: "Bank GL" }] : []),
        { key: "status", label: "Status" },
    ];

    const formattedVouchers = vouchers.map(voucher => ({
        ...withFeeCollectionExtraFields(voucher),
        member_status: voucher?.invoice?.trainer_fee === 0 || voucher?.invoice?.trainer_fee === null
            ? "General"
            : "Trainer",
        memberId : voucher?.location_id?.member_id_temp + voucher?.member_id?.member_id,
        paid_date:
            voucher?.voucher_type === 'Receipt'
                ? voucher?.receipt?.created_at || voucher?.voucher_date
                : voucher?.invoice?.payment_date,
        status:
            voucher?.voucher_type === 'Receipt'
                ? 'Paid'
                : voucher?.invoice?.payment_status || 'Expired',
        bank_gl: voucher?.bank_gl || '',
    }));

    createExcelAndDownload("Fee Collection Report", formattedVouchers, customHeadings);
}
